jQuery(document).ready(function () {
  htmladdClass();
  slider();
  wowo(jQuery);
  headerMenu();
  pageInnerScroll();
  insta();
  accordion();
  movieplay();
  video();
  agreeinput();
  footerinput();
  headercart();
  cursor();
  videoplay();

  // jQuery('video').get(0).play();
  // document.addEventListener('touchstart', function () {
  //   var videoElement = document.getElementById('myVideo');
  //   videoElement.play();
  // });

  // if (hash === '#ContactFooter') {
  //   jQuery('.loading').css('display', 'none');
  // }

  // jQuery('#myVideo').on('canplaythrough', function () {
  //   console.log("视频#myVideo已经加载完成");
  //   havevideotime();
  // });
});


window.onload = function () {
  setTimeout(function () {
    jQuery('.loading').fadeOut(300);
    havevideotime();
  }, 500);
}

let scrollY = window.scrollY;

jQuery(window).scroll(function () {
  wowo(jQuery);

  if (jQuery(document).scrollTop() > 60) {
    jQuery('.header').addClass('sticky');
  } else {
    jQuery('.header').removeClass('sticky');
  }

  let currentY = window.scrollY;

  scrollY = currentY;
  // cursor1();
});

function cursor() {
  if (jQuery(window).width() >= 992) {
    // let cursor;
    // let x = 0, y = 0;

    // function updateCursorPosition(e) {
    //   if (jQuery(window).width() >= 768) {
    //     cursor = jQuery('.dots');

    //     if (cursor.length) {
    //       x = e.pageX - cursor.width() / 2;
    //       y = e.pageY - cursor.height() / 2;
    //       cursor.css('left', x);
    //       cursor.css('top', y);
    //     }
    //   }
    //   requestAnimationFrame(updateCursorPosition);
    // }

    // jQuery('body').on('mousemove', function (e) {
    //   updateCursorPosition(e);
    // });

    // jQuery('a').on('mouseenter', function (e) {
    //   jQuery('body').addClass('changecolor');
    // });

    // jQuery('a').on('mouseleave', function (e) {
    //   jQuery('body').removeClass('changecolor');
    // });

    // jQuery('li').on('mouseenter', function (e) {
    //   jQuery('body').addClass('changecolor');
    // });

    // jQuery('li').on('mouseleave', function (e) {
    //   jQuery('body').removeClass('changecolor');
    // });

    // jQuery('.submit').on('mouseenter', function (e) {
    //   jQuery('body').addClass('changecolor');
    // });

    // jQuery('.submit').on('mouseleave', function (e) {
    //   jQuery('body').removeClass('changecolor');
    // });
  }
}

jQuery(window).resize(function () {
});

function havevideotime() {
  if(jQuery('#myVideo').length){
  var video = jQuery('#myVideo')[0];
  var video1 = jQuery('#myVideo1')[0];
  video.addEventListener('timeupdate', function () {
    var currentTime = video.currentTime;
    // console.log(currentTime)
    var duration = video.duration;
    // console.log(duration)
    var percentage = (currentTime / duration) * 100;
    // console.log(percentage)

    if (percentage >= 0 && percentage < 41) {
      jQuery('.span1, .span2').css('opacity', '1');
    } else if (percentage >= 41 && percentage < 61) {
      jQuery('.span3').addClass('slide-an');
      jQuery('.span1, .span2').css('opacity', '0');
    } else if (percentage >= 61 && percentage < 64) {
      jQuery('.span3').removeClass('slide-an');
    } else if (percentage >= 64 && percentage < 80) {
      jQuery('.span4').addClass('slide-an');
      jQuery('.span1, .span2').css('opacity', '0');
    } else if (percentage >= 80 && percentage < 84) {
      jQuery('.span4').removeClass('slide-an');
    } else if (percentage >= 84 && percentage < 100) {
      jQuery('.span1, .span2').css('opacity', '1');
    } else {
      jQuery('.span1, .span2').css('opacity', '0');
    }
  });

  video1.addEventListener('timeupdate', function () {
    var currentTime = video1.currentTime;
    var duration = video1.duration;
    var percentage = (currentTime / duration) * 100;

    if (percentage >= 0 && percentage < 41) {
      jQuery('.span1_mb, .span2_mb').css('opacity', '1');
    } else if (percentage >= 41 && percentage < 61) {
      jQuery('.span3_mb').addClass('slide-an');
      jQuery('.span1_mb, .span2_mb').css('opacity', '0');
    } else if (percentage >= 61 && percentage < 64) {
      jQuery('.span3_mb').removeClass('slide-an');
    } else if (percentage >= 64 && percentage < 80) {
      jQuery('.span4_mb').addClass('slide-an');
      jQuery('.span1_mb, .span2_mb').css('opacity', '0');
    } else if (percentage >= 80 && percentage < 84) {
      jQuery('.span4_mb').removeClass('slide-an');
    } else if (percentage >= 84 && percentage < 100) {
      jQuery('.span1_mb, .span2_mb').css('opacity', '1');
    } else {
      jQuery('.span1_mb, .span2_mb').css('opacity', '0');
    }
  });
  }
}

function headercart() {
  var cartIconBubble = jQuery('#cart-icon-bubble');
  var cartCountBubble = cartIconBubble.find('.cart-count-bubble');

  if (cartCountBubble.length > 0) {
    cartIconBubble.addClass('newClass');
  } else {
    cartIconBubble.removeClass('newClass');
  }

  setInterval(function () {
    cartCountBubble = cartIconBubble.find('.cart-count-bubble');
    if (cartCountBubble.length > 0) {
      cartIconBubble.addClass('newClass');
    } else {
      cartIconBubble.removeClass('newClass');
    }
  }, 1000);
}

function wowo($) {
  jQuery('html').addClass("show-c");

  setTimeout(function () {
    var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
      var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
        limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");
        setTimeout(function () {
          me.removeClass("animated wowo");
        }, 1500);
      }
    })
  }, 100);
}

function accordion() {
  jQuery('.accordion .item .item-head').on('click', function (e) {
    var index = jQuery(this).parent('.item').index();
    var dotsListItems = jQuery('.dots-list-item');
    var prevClickedItem = jQuery('.dots-list-item.active');
    if (prevClickedItem.length) {
      prevClickedItem.removeClass('newclass active');
    }

    jQuery(this).toggleClass('newclass');
    jQuery(this).parents('.item').siblings().find('.item-head').removeClass('newclass');
    if (jQuery(this).hasClass('newclass')) {
      dotsListItems.eq(index).addClass('active');
    } else {
      dotsListItems.eq(index).removeClass('active');
    }
    jQuery(this).siblings('.item-body').slideToggle(300);
    jQuery(this).parents('.item').siblings().find('.item-body').slideUp(300);
    jQuery(this).parents('.item').siblings().find('.item-head').removeClass('active newclass');
  });

  let content = jQuery(".accordion")[0];
  let lis = jQuery(".accordion li");

  jQuery(".accordion  li").click(function () {
    lis.removeClass("currentopen");
    jQuery(this).addClass("currentopen");
  });

  jQuery('.accordion-box .item .item-head').on('click', function (e) {
    var index = jQuery(this).parent('.item').index();
    var dotsListItems = jQuery('.dots-list-item');

    dotsListItems.removeClass('active');
    dotsListItems.eq(index).addClass('active');

    jQuery(this).toggleClass('newclass');
    jQuery(this).siblings('.item-body').slideToggle(300);
    jQuery(this).parents('.item').siblings().find('.item-body').slideUp(300);
    jQuery(this).parents('.item').siblings().find('.item-head').removeClass('active');
    jQuery(this).parents('.item').siblings().find('.item-head').removeClass('newclass');
  })

  let content1 = jQuery(".accordion-box")[0];
  let lis1 = jQuery(".accordion-box li");

  jQuery(".accordion-box li").click(function () {
    lis1.removeClass("currentopen");
    jQuery(this).addClass("currentopen");
  });

  jQuery('.dots-list-item').click(function () {
    var index = jQuery(this).index();
    var accordion = jQuery('.accordion .item');

    accordion.eq(index).show();

    if (index === 0) {
      accordion.eq(0).find('.item-body').slideDown(300);
      accordion.slice(1).each(function () {
        jQuery(this).find('.item-body').slideUp(300);
      });
      jQuery('.dots-list-item').not(':first').removeClass('active');
      jQuery(this).addClass('active');
      accordion.eq(0).find('.item-head').addClass('newclass');
      accordion.eq(1).find('.item-head').removeClass('newclass');
      accordion.eq(2).find('.item-head').removeClass('newclass');
    } else if (index === 1) {
      accordion.eq(1).find('.item-body').slideDown(300);
      accordion.slice(0, 1).each(function () {
        jQuery(this).find('.item-body').slideUp(300);
      });
      jQuery('.dots-list-item').not(':nth-child(2)').removeClass('active');
      jQuery(this).addClass('active');
      accordion.eq(0).find('.item-head').removeClass('newclass');
      accordion.eq(1).find('.item-head').addClass('newclass');
      accordion.eq(2).find('.item-head').removeClass('newclass');
    } else if (index === 2) {
      accordion.eq(2).find('.item-body').slideDown(300);
      accordion.slice(0, 2).each(function () {
        jQuery(this).find('.item-body').slideUp(300);
      });
      jQuery('.dots-list-item').not(':nth-child(3)').removeClass('active');
      jQuery(this).addClass('active');
      accordion.eq(0).find('.item-head').removeClass('newclass');
      accordion.eq(1).find('.item-head').removeClass('newclass');
      accordion.eq(2).find('.item-head').addClass('newclass');
    }
  });
}

function htmladdClass() {
  jQuery('#cart-icon-bubble').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').addClass('overflow-hidden');
  });

  jQuery('.drawer__close').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').removeClass('overflow-hidden');
  });

  jQuery('.drawer__inner').on('click', function (e) {
    e.stopPropagation();
  });

  jQuery('body').on('click', function (e) {
    jQuery('html').removeClass('overflow-hidden');
  });
}

function headerMenu() {
  jQuery('.burger-btn').on('click', function (e) {
    e.preventDefault();
    if (jQuery(window).width() < 993) {
      jQuery(this).toggleClass('active');
      jQuery('.header').toggleClass('active');
      jQuery('html').toggleClass('overflow-hidden');
      jQuery('.header .header-mobile').toggleClass('active');
      jQuery('.header').removeClass('sticky');
      jQuery('.header .menu li').toggleClass('fade');
    }
  });
}

function videoplay() {
  jQuery('.banner').click(function () {
    jQuery('#myVideo')[0].play();
  });
}

function pageInnerScroll() {
  jQuery('.backtotop').click(function () {
    jQuery('html, body').animate({ scrollTop: 0 }, 800);
    return false;
  });
}

function insta() {
  if (jQuery("#instafeed").length > 0) {
    var InstagramToken = jQuery("#instafeed").attr("data-key");
    var link = jQuery("#instafeed").attr("data-link");
    var feed = new Instafeed({
      accessToken: InstagramToken,
      limit: 12,
      template: '<div class="paralax__image "><img src="{{image}}"></img></div>',
      after: function () {
        jQuery('.paralax-insta__images:not(".slick-initialized")').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          speed: 500,
          autoplay: true,
          autoplaySpeed: 3000,
          focusOnSelect: true,
          infinite: true,
          draggable: true,
          prevArrow: jQuery('.slither .icon-box .icon-arrow-left'),
          nextArrow: jQuery('.slither .icon-box .icon-arrow-right'),
        });

        wowo();
      },
    });
    feed.run();
  }
}

function movieplay() {
  var video = document.getElementById("myVideo");
  // video.onended = function () {
  //   jQuery('#pauseBtn').removeClass("play");
  // };

  jQuery("#myVideo,#pauseBtn").on("click", function () {
    if (video.paused) {
      video.play();
      jQuery('#pauseBtn').addClass("play");
    } else {
      video.pause();
      jQuery('#pauseBtn').removeClass("play");
    }
  });
}

function video() {
  // var videoElements = document.querySelectorAll('video');
  // videoElements.forEach(function (videoElement) {
  //   var videoSrc = videoElement.getAttribute('src');
  //   if (videoSrc && videoSrc.endsWith('.mp4')) {
  //   } else {
  //     var hls = new Hls();
  //     hls.loadSource(videoSrc);
  //     hls.attachMedia(videoElement);
  //   }
  // });
}

function slider() {
  if (jQuery('.img-text-banner .img-banner-slider').length > 0) {
    jQuery('.img-text-banner .img-banner-slider:not(".slick-initialized")').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 3000,
      focusOnSelect: true,
      infinite: true,
      draggable: true,
      fade: true,
      prevArrow: jQuery('.slither .icon-box .icon-arrow-left'),
      nextArrow: jQuery('.slither .icon-box .icon-arrow-right'),
    });
  }
  if (jQuery('.text-content-slider .text-slider').length > 0) {
    jQuery('.text-content-slider .text-slider:not(".slick-initialized")').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 3000,
      focusOnSelect: true,
      infinite: true,
      draggable: true,
      prevArrow: jQuery('.text-content-slider .icon-box .icon-arrow-left'),
      nextArrow: jQuery('.text-content-slider .icon-box .icon-arrow-right'),
    });
  }
}

function isEmail(email) {
  var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
  if (reg.test(email)) {
    return true;
  } else {
    return false;
  }
}

function agreeinput() {

  jQuery('#ContactForm .submit').on("click", function (e) {
    jQuery('input[aria-required="true"]').each(function () {
      if (jQuery(this).val() === '') {
        jQuery(this).addClass('addcolor1');
      } else {
        jQuery(this).removeClass('addcolor1');
      }
    })

    var emailval = jQuery('#ContactForm input[type="email"]');
    if (isEmail(emailval.val())) {
      jQuery(emailval).removeClass('addcolor1');
    } else {
      jQuery(emailval).addClass('addcolor1');
    }

    if (!jQuery('input[name="Agree"]').is(':checked')) {
      e.preventDefault();
      jQuery('.checked-label label').addClass('addcolor');
      jQuery('.checked-label input').addClass('addcolor');
      return false;
    } else {
      jQuery('.checked-label input').removeClass('addcolor');
      jQuery('.checked-label label').removeClass('addcolor');
    }
  });

}

function footerinput() {
  jQuery('.footer-top .newsletter-form__button').on("click", function (e) {
    jQuery('input[aria-required="true"]').each(function () {
      if (jQuery(this).val() === '') {
        jQuery(this).addClass('addcolor1');
      } else {
        jQuery(this).removeClass('addcolor1');
      }
    })

    var emailval = jQuery('.footer-top input[type="email"]');
    if (isEmail(emailval.val())) {
      jQuery(emailval).removeClass('addcolor1');
      // return false;
    } else {
      jQuery(emailval).addClass('addcolor1');
    }
  });
}

function appHeight() {
  const doc = document.documentElement;
  doc.style.setProperty('--vh', (window.innerHeight * .01) + 'px');
}

window.addEventListener('resize', appHeight);
appHeight();